var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIssues(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3328 8.99999V13M12.3328 17H12.3428M10.9481 3.89171L2.72319 18.0983C2.26699 18.8863 2.03889 19.2803 2.0726 19.6037C2.10201 19.8857 2.24978 20.142 2.47913 20.3088C2.74209 20.5 3.19735 20.5 4.10788 20.5H20.5576C21.4682 20.5 21.9234 20.5 22.1864 20.3088C22.4157 20.142 22.5635 19.8857 22.5929 19.6037C22.6266 19.2803 22.3985 18.8863 21.9423 18.0983L13.7174 3.89171C13.2629 3.10654 13.0356 2.71396 12.7391 2.58211C12.4804 2.4671 12.1851 2.4671 11.9265 2.58211C11.6299 2.71396 11.4026 3.10655 10.9481 3.89171Z",
    stroke: "#0098A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssues);
export default __webpack_public_path__ + "e74a97f04808f12cc1a9d26a6eac8642.svg";
export { ForwardRef as ReactComponent };